import {
  Box,
  Image,
  StylesProvider,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import okappkyLogo from '../assets/images/logo-ok-appky.svg'
import { BaseMenu } from './BaseMenu'
import { Container } from './Container'
import { EnvironmentBadge } from './EnvironmentBadge'
import { MobileMenu } from './Menu/MobileMenu'

interface HeaderProps {
  variant?: string
}

export const BaseHeader = ({ variant }: HeaderProps) => {
  const styles = useMultiStyleConfig('Header', { variant })

  return (
    <Box __css={styles.header}>
      <StylesProvider value={styles}>
        <Container>
          <Box __css={styles.content} as="nav">
            <Box
              __css={styles.logo}
              sx={{ position: 'relative' }}
              as={Link}
              to="/"
            >
              <EnvironmentBadge />

              <Image src={okappkyLogo} alt="" width="160px" height="24px" />
            </Box>

            <BaseMenu />

            <MobileMenu />
          </Box>
        </Container>
      </StylesProvider>
    </Box>
  )
}
